/*
 * Upsell sheet on "Kjøp nå" (snippets/upsell-sheet.liquid). product-form.js asks
 * window.MadUpsellSheet.open(productForm) before it sends the cart request; the sheet then
 * calls back with the add-on to include (or none) and the form continues to checkout.
 * Shown on every "Kjøp nå" press (the sheet itself blocks double-opening).
 *
 * Prices follow the add-on's own product page: the Kaching Bundles deal (Enkelt / Duo / Trio)
 * is shared by both products, so 1 pack costs the page price, 2 packs the Duo price and
 * 3 packs the Trio price, and a subscription takes the plan's discount (10 %) on top. The
 * add-on line is tagged as a bundle line of that deal, so checkout charges the same amount
 * (see product-form.js addonsOnly).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-upsell-sheet]');
  if (!root) return;

  var panel = root.querySelector('.upsell-sheet__panel');
  var optSub = root.querySelector('[data-upsell-opt="sub"]');
  var optOne = root.querySelector('[data-upsell-opt="one"]');
  var qtyLabel = root.querySelector('[data-upsell-qty]');
  var minus = root.querySelector('[data-upsell-minus]');
  var plus = root.querySelector('[data-upsell-plus]');
  var total = root.querySelector('[data-upsell-total]');
  var subPrice = root.querySelector('[data-upsell-sub-price]');
  var subSave = root.querySelector('[data-upsell-sub-save]');
  var onePrice = root.querySelector('[data-upsell-one-price]');
  var oneSave = root.querySelector('[data-upsell-one-save]');
  var addBtn = root.querySelector('[data-upsell-add]');
  var skipBtn = root.querySelector('[data-upsell-skip]');
  var done = root.querySelector('[data-upsell-done]');

  var variant = root.dataset.variant;
  var price = parseInt(root.dataset.price, 10) || 0;           // cents per pack, the page price
  var withName = root.dataset.with || 'hovedproduktet';
  var max = parseInt(root.dataset.max, 10) || 3;
  var units = parseInt(root.dataset.units, 10) || 30;
  var plans = [];
  try { plans = JSON.parse(root.querySelector('[data-upsell-plans]').textContent) || []; } catch (e) {}

  // The Kaching Bundles deal on this page: its quantity tiers price the add-on as well.
  var deal = null;
  (function readDeal() {
    var scripts = document.querySelectorAll('script.kaching-bundles-deal-block-settings');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var d = JSON.parse(scripts[i].textContent);
        if (!d || !d.nanoId || !Array.isArray(d.dealBars)) continue;
        var bars = [];
        d.dealBars.forEach(function (b) {
          if (b.dealBarType !== 'quantity-break' || !b.id || !b.quantity) return;
          bars.push({ id: b.id, qty: b.quantity, pct: b.discountType === 'percentage' ? Number(b.discountValue) || 0 : 0 });
        });
        if (bars.length) { deal = { deal: d.nanoId, v: d.versionId, bars: bars }; return; }
      } catch (e) {}
    }
  })();

  var qty = 1;
  var mode = 'one';
  var plan = null;       // the selling plan the add-on would be put on
  var form = null;       // the product-form element waiting for an answer
  var lastFocus = null;

  function money(cents) {
    var fmt = root.dataset.moneyFormat || '{{amount}} kr';
    var v = cents / 100;
    // the shop shows whole kroner ({{amount_no_decimals}}), so 179,10 reads "179 kr" here as well
    if (/no_decimals/.test(fmt)) v = Math.round(v);
    var whole = v % 1 === 0;
    var s = whole ? String(Math.round(v)) : v.toFixed(2).replace('.', ',');
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '').trim();
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  // The price a plan charges for one pack, in cents. Liquid gives fixed_amount and price
  // adjustments in cents already (a 99 kr plan arrives as 9900).
  function planPrice(p) {
    if (!p) return price;
    if (p.type === 'percentage') return Math.round(price * (100 - p.value) / 100);
    if (p.type === 'fixed_amount') return Math.max(0, price - Math.round(p.value));
    if (p.type === 'price') return Math.round(p.value);
    return price;
  }

  // The deal tier that applies to a quantity (the largest tier not above it).
  function tier(q) {
    if (!deal) return null;
    var best = null;
    deal.bars.forEach(function (b) { if (b.qty <= q && (!best || b.qty > best.qty)) best = b; });
    return best;
  }

  // What checkout charges for q packs at a unit price: the tier's percentage off the line,
  // rounded up to whole kroner the way the app does (2 × 199 kr − 20 % = 318,40 → 319 kr).
  function lineTotal(unit, q) {
    var t = tier(q);
    var full = unit * q;
    if (!t || !t.pct) return Math.round(full);
    return Math.ceil(full * (100 - t.pct) / 100 / 100) * 100;
  }

  // Saving against the full price, as a badge ("−20 %"); empty when there is none.
  function savePct(full, now) {
    var pct = full > 0 ? Math.round((1 - now / full) * 100) : 0;
    return pct > 0 ? '−' + pct + ' %' : '';
  }

  function priceHtml(full, now) {
    if (now < full) return '<s>' + esc(money(full)) + '</s> ' + esc(money(now));
    return esc(money(now));
  }

  function render() {
    var full = price * qty;
    var one = lineTotal(price, qty);
    var sub = lineTotal(planPrice(plan), qty);
    qtyLabel.textContent = qty + ' · ' + qty * units + ' stk';
    onePrice.innerHTML = priceHtml(full, one);
    if (oneSave) oneSave.textContent = savePct(full, one);
    if (plan) {
      subPrice.innerHTML = priceHtml(full, sub);
      subSave.textContent = savePct(full, sub);
    }
    total.textContent = money(mode === 'sub' ? sub : one);
    optSub.setAttribute('aria-checked', mode === 'sub');
    optOne.setAttribute('aria-checked', mode === 'one');
    minus.disabled = qty <= 1;
    plus.disabled = qty >= max;
  }

  function currentPlan(pf) {
    var input = pf.form.querySelector('[name="selling_plan"]');
    var id = input && input.value ? String(input.value) : '';
    if (!id) return null;
    for (var i = 0; i < plans.length; i++) if (String(plans[i].id) === id) return plans[i];
    return null;
  }

  function shouldShow() {
    // Always offer the add-on. The only time we skip is while the sheet is already open.
    return root.hidden !== false || !root.classList.contains('is-open');
  }

  function open(pf) {
    form = pf;
    var matched = currentPlan(pf);
    // The customer's own plan when the upsell shares it; otherwise the upsell's first plan,
    // so the add-on can be subscribed to on its own.
    plan = matched || plans[0] || null;
    mode = matched ? 'sub' : 'one';
    optSub.hidden = !plan;
    if (plan) {
      var note = optSub.querySelector('[data-upsell-sub-note]');
      if (note) {
        note.textContent = matched
          ? 'Leveres sammen med ' + withName + ' · avbryt når du vil'
          : (String(plan.name || '').split('|')[0].trim() || 'Fast levering') + ' · avbryt når du vil';
      }
      // the option matching what the customer already chose comes first
      optSub.style.order = matched ? '0' : '1';
      optOne.style.order = matched ? '1' : '0';
    }
    qty = 1;
    render();
    lastFocus = document.activeElement;
    root.hidden = false;
    root.classList.remove('is-locked');
    done.hidden = true;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      panel.focus();
    });
    document.documentElement.classList.add('upsell-sheet-open');
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('upsell-sheet-open');
    setTimeout(function () { root.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function proceed(addons) {
    if (!form) return;
    form.upsellAnswered = true;
    form.pendingAddons = addons;
    var f = form.form;
    if (f.requestSubmit) f.requestSubmit();
    else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  optSub.addEventListener('click', function () { mode = 'sub'; render(); });
  optOne.addEventListener('click', function () { mode = 'one'; render(); });
  minus.addEventListener('click', function () { if (qty > 1) { qty--; render(); } });
  plus.addEventListener('click', function () { if (qty < max) { qty++; render(); } });

  addBtn.addEventListener('click', function () {
    var item = { id: variant, quantity: qty, product_id: root.dataset.product };
    if (mode === 'sub' && plan) item.selling_plan = plan.id;
    var t = tier(qty);
    if (t) item.kaching = { deal: deal.deal, v: deal.v, bid: t.id };
    root.classList.add('is-locked');
    done.hidden = false;
    proceed([item]);
  });
  skipBtn.addEventListener('click', function () {
    close();
    proceed([]);
  });
  // Backdrop or Escape: nothing happens, the customer stays on the page and can press Kjøp nå again.
  root.querySelector('[data-upsell-cancel]').addEventListener('click', function () {
    if (root.classList.contains('is-locked')) return;
    close();
    if (form) form.resetButton();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open') && !root.classList.contains('is-locked')) {
      close();
      if (form) form.resetButton();
    }
  });

  window.MadUpsellSheet = { open: open, shouldShow: shouldShow };
})();
